import constants from './BookingHistoryConstants';

const initialState = {
    history: [],
};


export default (state = initialState, action) => {
    switch (action.type) {
    case constants.SET_BOOKINGS: {
        return Object.assign({}, state, { history: action.payload });
    }
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/containers/BookingHistory/BookingHistoryReducer.js